import useAuthorized from "hooks/useAuthorized";

/**
 * Renders `children` only while the current user holds `permissions`.
 *
 * `partialMatch` mirrors `useAuthorized`: any single granted permission is
 * enough, instead of requiring all of them.
 */
const Authorized = ({ permissions = [], partialMatch = false, children }) => {
  const isAuthorized = useAuthorized(permissions, { partialMatch });

  return isAuthorized ? children : null;
};

export default Authorized;
